import React, { useState, useEffect } from "react";
import { Container, Button, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import axios from "axios";
import MenuAppBar from '../components/MenuAppBar';

export default function AppsForm() {
  const [apps, setApps] = useState([]);
  const [newApp, setNewApp] = useState("");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedApp, setSelectedApp] = useState(null);

  const getAuthHeaders = () => {
    const token = localStorage.getItem("accessToken");
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  useEffect(() => {
    axios.get("/api/apps", getAuthHeaders()).then((response) => {
      setApps(response.data);
      setLoading(false);
    });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleEdit = (app) => {
    setSelectedApp(app);
  };

  const handleSaveEdit = () => {
    if (selectedApp) {
      axios.post("/api/apps", selectedApp, getAuthHeaders()).then(() => {
        setApps((prev) => prev.map((app) => (app.idapps === selectedApp.idapps ? selectedApp : app)));
        setSelectedApp(null);
      });
    }
  };

  const handleAdd = () => {
    if (newApp.trim()) {
      axios.post("/api/apps", { idapps: "", appsName: newApp }, getAuthHeaders()).then((response) => {
        setApps((prev) => [...prev, response.data]);
        setNewApp("");
      });
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    
    
    <Container>
    <MenuAppBar title='Apps' />
      <TableContainer component={Paper}>
      
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Název</TableCell>
              <TableCell>Akce</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {apps.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((app) => (
              <TableRow key={app.idapps}>
                <TableCell>{app.appsName}</TableCell>
                <TableCell>
                  <Button variant="contained" onClick={() => handleEdit(app)}>Editovat</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={apps.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
      
        <TextField
          fullWidth
          variant="outlined"
          value={newApp}
          onChange={(e) => setNewApp(e.target.value)}
          placeholder="Nová aplikace"
        />
        <Button variant="contained" onClick={handleAdd}>Přidat</Button>
      
      {selectedApp && (
        <Dialog open={true} onClose={() => setSelectedApp(null)}>
          <DialogTitle>Editovat aplikaci</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              variant="outlined"
              value={selectedApp.appsName}
              onChange={(e) => setSelectedApp({ ...selectedApp, appsName: e.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setSelectedApp(null)}>Zrušit</Button>
            <Button variant="contained" onClick={handleSaveEdit}>Uložit</Button>
          </DialogActions>
        </Dialog>
      )}
    </Container>
  );
}
